import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const EditConfigModal = ({ show, handleClose, config }) => {
  const [updateConfig, setUpdateConfig] = useState({
    key: '',
    value: '',
  })

  useEffect(() => {
    if (config) {
      setUpdateConfig({
        key: config.key || '',
        value: config.value || '',
      })
    }
  }, [config])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdateConfig((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const { key, ...configData } = updateConfig
      const response = await ApiEndpoints.editConfig(
        config.setting_id,
        configData,
      )
      toast.success(response.data.message)
      handleClose()
    } catch (error) {
      toast.error(
        error.response?.data?.errors?.key?.[0] || 'Something wents wrong.',
      )
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton 
        closeVariant="white"
        className="bg-warning text-dark">
        <Modal.Title>Edit Config</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSaveChanges}>
          {/* Class Name Field */}
          <Form.Group className="mb-3">
            <Form.Label>Key</Form.Label>
            <Form.Control
              type="text"
              name="key"
              value={updateConfig.key}
              onChange={handleInputChange}
              placeholder="Enter Key"
              className="p-2 border rounded"
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Value</Form.Label>
            <Form.Control
              type="number"
              name="value"
              value={updateConfig.value}
              onChange={handleInputChange}
              placeholder="Enter value"
              className="p-2 border rounded"
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditConfigModal
